import { ChatBubble } from '../../model/chat-bubble.model';

export function filterQuotesByKeyword(
    keyWord: string | null,
    quotes: ChatBubble[],
): ChatBubble[] {
    if (keyWord == null || keyWord.trim().length === 0) {
        return [...quotes];
    }

    return quotes.filter((q) => {
        return q.message?.toLowerCase().includes(keyWord.toLowerCase());
    });
}
